import { IIcon } from '../../model';

export const greenDownArrow: IIcon = {
  id: 'GREEN-DOWN-ARROW',
  svg: '<path d="M10.58 0 6 4.33 1.41 0 0 1.33 6 7l6-5.67L10.58 0Z" fill="#47979D"/>',
};
